import { api } from '@/core/http/apiClient';
import type { CicReportView, SaveCicReportPayload } from '@/core/models/cic-report.models';

export const cicReportService = {
  get: (clientId: string, accountingPeriodId: string) =>
    api.get<CicReportView>(`CicReport/get/${clientId}/${accountingPeriodId}`),

  save: (payload: SaveCicReportPayload) => api.post<CicReportView>('CicReport/save', payload),
};
